import { getProductInboundTransaction } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRProductInboundTransaction = (productInboundTransactionId: string | null) => {
  const {
    data: productInboundTransaction,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(
    productInboundTransactionId ? `productInboundTransaction-${productInboundTransactionId}` : null,
    () => getProductInboundTransaction(productInboundTransactionId as string)
  );

  return {
    productInboundTransaction,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRProductInboundTransaction;
